import {hasChanged, isArray, isObject} from 'src/utils/utils';
import {track, trigger} from './effect';

const reactiveMap = new WeakMap();

export function reactive(target: any): any {
  if (!isObject(target)) return target;
  if (isReactive(target)) return target;
  if (reactiveMap.has(target)) return reactiveMap.get(target);
  const proxy = new Proxy(target, {
    //对象获取值时收集依赖
    get(target, key: string, receiver) {
      if (key === '__isReactive') {
        //判断是否为reactive方法
        return true;
      }
      track(target, key);
      //反射获取值
      const res = Reflect.get(target, key, receiver);
      //解决响应性嵌套问题 或者 数组
      return isObject(res) ? reactive(res) : res;
    },

    set(target, key: string, value, receiver) {
      // console.log('reactive setvalue');
      const oldValue = target[key];
      const oldLength = target.length;
      const res = Reflect.set(target, key, value, receiver);
      if (hasChanged(value, oldValue)) {
        trigger(target, key);
        if (isArray(target) && target.length !== oldLength) {
          //解决数组响应性
          trigger(target, 'length');
        }
      }
      return res;
    },
  });
  reactiveMap.set(target, proxy);
  return proxy;
}

/**
 * 判断是否是reactive 方法
 * @param target
 * @returns
 */
function isReactive(target: any) {
  return !!(target && target.__isReactive);
}
